import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as Constants from '@shared/_constants';
import { UserNotificationService } from '@services/user-notification.service';
import { UserNotification } from '@models/userNotification.model';
import { NgForm } from '@angular/forms';
import { NotificationType } from '../../mystudies/_study_constants';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-dialog-notifications',
  templateUrl: './dialog-notifications.component.html',
  styleUrls: ['./dialog-notifications.component.css'],
})
export class DialogNotificationsComponent implements OnInit {
  public dialogClass = '';
  public notifications: UserNotification[] = [];
  public unreadCount: number;
  public reportNotification = NotificationType.Report;

  /* START ONLY FOR TESTING NOTIFICATIONS */
  public notification: UserNotification = new UserNotification();
  /* END ONLY FOR TESTING NOTIFICATIONS */

  constructor(
    private activeModal: NgbActiveModal,
    private userNotificationService: UserNotificationService,
  ) {}

  async ngOnInit() {
    this.notifications = this.userNotificationService.getNotifications();
    this.unreadCount = this.userNotificationService.getUnreadNotificationCount();

    this.userNotificationService.notificationsChanged.subscribe((x) => {
      this.notifications = [...x];
    });

    this.userNotificationService.unreadCountChanged.subscribe((x) => {
      this.unreadCount = x;
    });
  }

  public deleteNotification(key: string) {
    this.userNotificationService.removeNotification(key);
    return false;
  }

  public deleteAllNotifications() {
    this.userNotificationService.removeAllNotifications();
    return false;
  }

  public markNotificationRead(key: string) {
    this.userNotificationService.markNotificationRead(key);
    return false;
  }

  public markAllNotificationsRead() {
    this.userNotificationService.markAllNotificationsRead();
    return false;
  }

  public markNotificationUnread(key: string) {
    this.userNotificationService.markNotificationUnread(key);
    return false;
  }

  public closeClick() {
    this.activeModal.close(Constants.ConfirmationResult.yes);
  }

  /* START ONLY FOR TESTING NOTIFICATIONS */
  public addNotification(form: NgForm) {
    if (form.valid) {
      const url = this.notification.url && this.notification.url.length > 0 ? this.notification.url : undefined;
      this.userNotificationService.addUpdateNotification(this.notification.key, this.notification.message, this.notification.isErrorMessage, url);
    }
  }
  /* END ONLY FOR TESTING NOTIFICATIONS */
}
